"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingContainer = (0, _styledBase["default"])("div", {
  target: "e1qp3ted0",
  label: "LoadingContainer"
})("height:100%;width:100%;justify-content:center;align-items:center;display:flex;font-size:18px;flex-direction:column;text-transform:none !important;", function (props) {
  return props.center && 'flex-grow: 1; margin-top: 0;';
});
var _default = LoadingContainer;
exports["default"] = _default;

//# sourceMappingURL=Loading.styles.js.map